import * as React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface ISeo {
  title: string;
  description?: string | null | undefined;
  image?: string | null | undefined;
}

export const Seo: React.FC<ISeo> = ({ title, description, image }) => {
  const location = useLocation();
  const baseURL = `https://privatmegleren.no${location.pathname}`;
  const url: string = `${baseURL}${location.search}`;
  const imageURL: string = image
    ? image
    : 'https://cdn.reeltime.no/pm_assets/img/PM_profilbilde.jpeg';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description ? description : ''} />
      <meta name="twitter:site" content="@PRIVAT_megleren" />
      <meta name="twitter:creator" content="@PRIVAT_megleren" />
      <meta name="twitter:card" content="" />
      <meta name="twitter:title" content={title} />
      <meta
        name="twitter:description"
        content={description ? description : ''}
      />
      <meta name="twitter:image:src" content={imageURL} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={imageURL} />
      <meta
        property="og:description"
        content={description ? description : ''}
      />
      <meta property="og:site_name" content="PrivatMegleren" />
      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description ? description : ''} />
      <meta itemProp="image" content={imageURL} />
      <meta name="p:domain_verify" content="f665a9d2e04bdc20ecfd4d18cdb87987" />
      <link rel="canonical" href={baseURL} />
    </Helmet>
  );
};
